import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function usePrevPath() {
  const { pathname, search } = useLocation();
  const prev = useRef("");

  useEffect(() => {
    if (prev.current) {
      sessionStorage.setItem("prevPath", prev.current);
    }
    prev.current = pathname + (search || "");
  }, [pathname, search]);
}
